import { STREAM, ORGA_HASH } from '../../../constants/dataGroup';

export const INITIAL_TERM = STREAM;

export const DISPLAYED_NAME_OF_TERM = {
   [STREAM]: 'Stream name',
   [ORGA_HASH]: 'Organization',
};

export const TERMS = () => [STREAM];

export default {
   INITIAL_TERM,
   DISPLAYED_NAME_OF_TERM,
   TERMS,
};
